import React from "react";
import FormTextField from "../../components/form/text";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormPasswordField from "../../components/form/password";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { url } from "../../config";
import logo from "../../assets/icons/FFlogo.png";

const LoginPage = () => {
  const navigate = useNavigate();

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Required").email("Invalid email"),
    password: Yup.string().required("Required"),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    axios
      .post(`${url}/ffadmin/auth/login`, values)
      .then((response) => {
        successToast(response?.data?.message || "Login successful!");
        localStorage.setItem("accessToken", response?.data?.data?.access_token);
        navigate("/dashboard");
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <main className="relative min-h-screen w-full flex items-center justify-center bg-slate-50 p-4 sm:p-6 overflow-hidden">
      <div className="absolute top-[-10%] left-[-10%] w-[450px] h-[450px] bg-[#F4B400]/25 rounded-full blur-[120px] pointer-events-none animate-blob-1" />
      <div className="absolute top-[-10%] right-[-10%] w-[450px] h-[450px] bg-[#0F9D58]/25 rounded-full blur-[120px] pointer-events-none animate-blob-2" />
      <div className="absolute bottom-[-10%] left-[-10%] w-[450px] h-[450px] bg-[#4285F4]/25 rounded-full blur-[120px] pointer-events-none animate-blob-3" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[450px] h-[450px] bg-[#EA4335]/25 rounded-full blur-[120px] pointer-events-none animate-blob-1" />

      <div className="relative w-full max-w-md bg-white/80 backdrop-blur-2xl border border-white/90 rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.06)] overflow-hidden">
        <div className="pt-8 px-8 pb-4 text-center">
          <div className="flex justify-center">
            <div className="w-20">
              <img src={logo} alt="FirstFloor" className="w-full" />
            </div>{" "}
          </div>

          <h1 className="text-2xl sm:text-3xl font-bold text-slate-800 tracking-tight">
            Welcome Back
          </h1>
          <p className="text-sm text-slate-500 mt-2">
            Please enter your admin credentials
          </p>
        </div>

        <div className="p-8 pt-4">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="space-y-5">
                <div className="space-y-4">
                  <FormTextField
                    name="email"
                    label="Email Address"
                    placeholder="name@company.com"
                  />

                  <FormPasswordField
                    name="password"
                    label="Password"
                    placeholder="Enter Password"
                  />
                </div>

                <div className="pt-2">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full relative py-3.5 px-4 bg-[#4285F4] hover:bg-[#3367D6] active:bg-[#2A56C6] text-white font-semibold rounded-2xl shadow-lg shadow-[#4285F4]/30 transition-all duration-200 ease-in-out transform active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                  >
                    {isSubmitting ? (
                      <span className="inline-block animate-spin rounded-full h-5 w-5 border-2 border-white/30 border-t-white" />
                    ) : (
                      "Sign In"
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>

        {/* Footer */}
        <div className="bg-slate-50/70 border-t border-slate-100 py-4 text-center">
          <p className="text-xs text-slate-500 font-medium flex items-center justify-center gap-1.5 transition-colors duration-200">
            <span>Made with</span>
            <span className="text-[#EA4335] animate-pulse text-sm inline-block leading-none">
              ♥
            </span>
            <span>by</span>
            <span className="font-semibold text-[#4285F4] hover:text-[#3367D6] transition-colors cursor-pointer">
              FirstFloor
            </span>
          </p>
        </div>
      </div>
    </main>
  );
};

export default LoginPage;
